import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  const currentYear = new Date().getFullYear();

  const linkStyle = { color: 'white', textDecoration: 'none', margin: '0 0.75rem' };
  const footerStyle = { backgroundColor: '#2c3e50', color: 'white', paddingTop: '2rem', paddingBottom: '2rem' };
  const navContainerStyle = { display: 'flex', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap', listStyle: 'none', padding: 0, margin: 0 };

  return (
    <footer style={footerStyle}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 1rem' }}>
        <ul style={navContainerStyle}>
          <li><Link to="/terms-of-service" style={linkStyle}>Terms of Service</Link></li>
          <li><Link to="/privacy-policy" style={linkStyle}>Privacy Policy</Link></li>
          <li><Link to="/about-us" style={linkStyle}>About Us</Link></li>
        </ul>
        <div style={{ textAlign: 'center', marginTop: '1.5rem', color: '#bdc3c7', fontSize: '0.9em' }}>
          <p style={{ margin: '0.5rem 0' }}>CodeMates Software Limited</p>
          <p style={{ margin: '0.5rem 0' }}>RM 1805-06 18/F HOLLYWOOD PLZ</p>
          <p style={{ margin: '0.5rem 0' }}>610 NATHAN RD</p>
          <p style={{ margin: '0.5rem 0' }}>MONGKOK, HONG KONG</p>
          <p style={{ margin: '0.5rem 0' }}>Telephone: +1 478-200-9849</p>
          <p style={{ margin: '1rem 0' }}>For support, inquiries, or partnership opportunities, please email us at <a href="mailto:support@codemates.app" style={{color: 'white', textDecoration: 'underline'}}>support@codemates.app</a>.</p>
        </div>
      </div>
      
      <div style={{ textAlign: 'center', marginTop: '1.5rem', paddingTop: '1.5rem', borderTop: '1px solid #444' }}>
        <p style={{ margin: 0, color: '#bdc3c7', fontSize: '0.9em' }}>&copy; {currentYear} CodeMates. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer; 